// extracted by mini-css-extract-plugin
export default {"editName":"common_editName__THVuT","actionButtons":"common_actionButtons__acnR2","button":"common_button__KdwXN"};